export enum ShareDeviceStatus {
  VALID = 'VALID',
  INVALID_EMAIL = 'INVALID_EMAIL',
  INVITE_EXPIRED = 'INVITE_EXPIRED',
  SUBSCRIBE = 'SUBSCRIBE',
  WEBAPP = 'WEBAPP',
}
